<template>
  <div class="curtain">
    <v-card style="margin: 37vh auto; width: 200px; padding: 20px 30px; border-radius: 20px">
      <div class="wrapper">
        <img class="logo front" alt="logo" src="@/assets/uv-logo-full.png" />
        <img class="logo back" alt="logo" src="@/assets/uv-logo-full.png" />
      </div>
      <h4 class="grey--text">Loading...</h4>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Waiting',
  props: ['waiting']
}
</script>

<style scoped>
.curtain {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 155vh;
  background: #69696980;
  z-index: 500
}

img.logo {
  display: block;
  margin: 0 auto;
  width: 100%;
  padding: 20px 0px;
}

.wrapper{
  perspective: 2000px;
  width: 150px;
  height: 150px;
  position: relative;
}

.front, .back{
  backface-visibility: hidden;
  position: absolute;
  left: 0;
  top: 0;
}

.front {
  animation: front-rotation 1s infinite;
}
.back {
  transform: rotateY(180deg);
  animation: back-rotation 1s infinite;
}

@keyframes front-rotation{
  from {
    background-image:url('~@/assets/uv-logo-full.png');
    transform: rotateY(0deg);
  }
  to {
    background-image:url('~@/assets/uv-logo-full.png');
    transform: rotateY(360deg);
  }
}
@keyframes back-rotation{
  from {
    background-image:url('~@/assets/uv-logo-full.png');
    transform: rotateY(180deg);
  }
  to {
    background-image:url('~@/assets/uv-logo-full.png');
    transform: rotateY(540deg);
  }
}
</style>
